import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import s from './ExpertDataProjects.scss';
import ProfilePortfolio from './ProfilePortfolio';
import { TextButton } from 'wix-style-react';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import ChevronUp from 'wix-ui-icons-common/ChevronUp';
import ExpertDataTitle from '../ExpertDataTitle/ExpertDataTitle';
import { PageWidthBreakPoint } from '../../../../utils/constants';
import { ServicesProvider } from '@wix/experts-common';
import isServer from '../../../../utils/isServer';

class ExpertDataProjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreProjects: true,
    };
  }

  static propTypes = {
    t: PropTypes.func,
    projects: PropTypes.array,
    expertGuid: PropTypes.string,
    isMyProfile: PropTypes.bool,
    staticsBaseUrl: PropTypes.string,
  };

  static defaultProps = {
    isMyProfile: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.projects !== prevProps.projects) {
      this.setState({ showMoreProjects: true });
    }
  }

  handleShowMore(showMoreProjects) {
    this.context.services.withBI(
      {
        evid: 147,
        typeid: 1,
        proGuid: this.props.expertGuid,
      },
      this.setState({ showMoreProjects }),
    );
  }

  render() {
    const { t, projects, isMyProfile, expertGuid, staticsBaseUrl } = this.props;
    const { showMoreProjects } = this.state;
    const { isInModal } = this.context.services;
    const isTabletOrDesktop = isServer
      ? true
      : window.matchMedia(PageWidthBreakPoint.Width_Tablet).matches;

    return (
      <div className={s.expertDataProjects}>
        <div className={s.title} data-hook="expert-data-projects-title">
          <ExpertDataTitle
            title={t('client-expertview-projects-title')}
            tabName="portfolio"
            showEditProfileLink={isMyProfile && !isInModal}
          />
        </div>
        <ProfilePortfolio
          projects={projects}
          showMoreProjects={showMoreProjects}
          expertGuid={expertGuid}
          staticsBaseUrl={staticsBaseUrl}
        />
        {isTabletOrDesktop && showMoreProjects && (
          <TextButton
            dataHook="show-more-projects"
            onClick={() => {
              this.handleShowMore(false);
            }}
            skin="dark"
            weight="normal"
            suffixIcon={<ChevronDown />}
          >
            {t('client-expertview-showmore')}
          </TextButton>
        )}
        {isTabletOrDesktop && !showMoreProjects && (
          <TextButton
            dataHook="show-less-projects"
            onClick={() => {
              this.setState({ showMoreProjects: true });
            }}
            skin="dark"
            weight="normal"
            suffixIcon={<ChevronUp />}
          >
            {t('client-expertview-showless')}
          </TextButton>
        )}
      </div>
    );
  }
}

ExpertDataProjects.contextTypes = ServicesProvider.childContextTypes;
export default translate()(ExpertDataProjects);
